export async function loadStyle(path) {
  const response = await fetch(path)
  return await response.text()
}
